import { render, staticRenderFns } from "./X.vue?vue&type=template&id=03c07598&scoped=true"
import script from "./X.vue?vue&type=script&lang=js"
export * from "./X.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c07598",
  null
  
)

export default component.exports